<template>
  <sidebar-clients-button />
  <sidebar-create-appointment />
  <!-- <sidebar-createjob /> -->
  <div id="sidebar-calendar">
    <Calendar
      borderless
      expanded
      :attributes="attrs"
      :timezone="timezone"
      @dayclick="dayClicked"
    />
  </div>
  <hr />
  <SidebarJobCount />
</template>

<script>
import { Calendar } from "v-calendar";
import "v-calendar/style.css";
import { useDateStore } from "./../../stores/datestore.js";
import { ref, watch } from "vue";
import sidebarCreateAppointment from "./sidebar/create-appointment.vue";
import sidebarClientsButton from "./sidebar/clients-button.vue";
import SidebarJobCount from "./sidebar/jobcount.vue";
import { createUTCDate } from "./../../libs/date";

export default {
  name: "CalendarSidebar",
  components: {
    Calendar,
    sidebarCreateAppointment,
    sidebarClientsButton,
    SidebarJobCount,
  },
  setup() {
    const dateStore = useDateStore();
    const attrs = ref([
      {
        key: "today",
        highlight: "blue",
        dates: [createUTCDate(new Date())],
      },
      {
        key: "selected-date",
        content: "red",
        highlight: {
          fillMode: "outline",
        },
        dates: [dateStore.selectedDate],
      },
    ]);
    watch(
      () => dateStore.selectedDate,
      () => {
        attrs.value.filter((attr) => {
          if (attr.key === "selected-date")
            attr.dates = [dateStore.selectedDate];
        });
      }
    );
    return { dateStore, attrs };
  },
  data() {
    return {
      dialog: false,
      timezone: "UTC",
    };
  },
  methods: {
    dayClicked(calendarDay) {
      this.dateStore.setDate(calendarDay.date);
    },
  },
};
</script>

<style>
#sidebar-calendar {
  margin-top: 10px;
}

#sidebar-btn {
  margin: 20px 0px;
}
.vc-day {
  min-height: auto;
  max-height: 24px;
  max-width: 24px;
}

.vc-day-content {
  height: 24px;
  width: 24px;
  font-size: 11px;
}

.vc-weekday {
  font-size: 11px;
  line-height: 11px;
}

.vc-header.is-lg {
  font-size: 14px;
}

.vc-pane {
  min-width: 200px;
}

.vc-weeks {
  min-width: 170px;
}

.vc-highlight {
  width: 20px;
  height: 20px;
}

.vc-monthly .is-not-in-month * {
  opacity: 0.5;
}

.v-btn--variant-outlined {
  border: thin solid rgb(218, 220, 224);
}
</style>
